export enum WsStatus {
	CONNECTING,// 连接中
	CONNECTED,// 已连接
	DISCONNECTED,// 已断开
}

// 套餐枚举
export enum PackageType {
   FREE,//免费版(为啥是free，因为一开始需求是免费的，字段定了，然后后面又改成收费的了)
   VIP,//入门版
   VIP1,//基础版
   VIP2,//进阶版
}

//每个套餐可选择的算法数量
export const PackageSrvSelected = {
	0:0,
	1:4,
	2:12,
	3:22,
}

//基础版可选择的算法数量限制
export const FreePackageSrvSelecteds = [1,9,10,12];

//这几种AI算法只能在大模型下
export const AISrvInBigModel = [19,20,21,22]

export enum PackageStatus {
   NORMAL=1,//正常
   EXPIRED=2,//到期
   NOT_ACTIVIVATED=3,//未激活
   RENEWED=4,//已续费
}

export enum LoginModel {
    GLASSSIX='glasssix',//商户管理平台跳转登录
    TENANT='tenant',//普通用户登录
}
